import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import { fetchData } from "../../redux/actions";
import { our_story } from '../../redux/selectors';
import { underscoresToHighlights } from '../../utils/parse-text';

const Story = () => {
    const dispatch = useDispatch();
    const data = useSelector(our_story("our_story"));
    
    useEffect(() => {
        if (!data || data.length === 0) {  
            dispatch(fetchData("our_story","pages?path=/company-info/our-story"));
        }
        }, [dispatch, data]);   
    
    const storyContent = data?.our_story?.[0]?.attributes;
    const stories = data?.stories_area;

    const seo_data = useSelector((state) => state?.seo_data?.seo_data) ?? {};

    return (
        <>
            {seo_data && (
                <Helmet>                    
                    <title>{seo_data?.title }</title>   
                    <meta name="description" content={seo_data?.description}  />
                    <meta property="og:title" content={seo_data?.title} />
                    <meta property="og:description" content={seo_data?.description} />                 
                </Helmet>          
            )}
            <section className="hot-deals pt-80">            
                <div className="container container-lg">
                    {/* component 1 */}
                    <div className="row gy-4">
                        <div className="col-sm-6">                        
                            <div className="flex-between flex-wrap gap-8">
                                <h5 
                                    className="mb-0"
                                    dangerouslySetInnerHTML={{ __html: underscoresToHighlights(storyContent?.title) }}
                                />
                            </div>                        
                            <div className="row g-12 mt-10">                    
                                <h6
                                    className="mb-0 text-blue"
                                    dangerouslySetInnerHTML={{ __html: underscoresToHighlights(storyContent?.subtitle) }}
                                />                    
                            </div>
                            <div className="my-4 mb-6 h-px w-full bg-medium-electric-blue md:my-6" />
                            <div className="pb-6" dangerouslySetInnerHTML={{ __html: storyContent?.description }} />
                            <div>
                                {storyContent?.buttons?.map(button => (
                                    <Link
                                        to={button?.attributes?.link?.en}
                                        className="text-blue hover-text-main-600"
                                    >
                                        <div>{button?.attributes?.title}</div>    
                                    </Link>
                                ))}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <img
                                src={storyContent?.image?.files?.medium?.url}
                                alt="story"
                            />
                        </div>
                    </div>
                    {/* component 2 */}
                    <div className="row bg-light-grey">
                        <div className="row g-12  ">                    
                            <h6 className="mb-0 text-blue text-center">     
                                {storyContent?.bullet_points?.[0]?.attributes?.subtitle}
                            </h6>               
                        </div>
                        <div className="my-4 mb-6 h-px w-full bg-medium-electric-blue md:my-6 mt-20" />
                        <div>
                            <ul className="">
                                {storyContent?.bullet_points?.[0]?.attributes?.bullet_point?.map(bullet => (
                                    <li className="flex text-content text-dark" key={bullet.key}>
                                        <div>{bullet.attributes?.text}</div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    {/* component 3 */}
                    <div >
                        {stories?.map(story => (
                            <div className="row gy-4">
                                <div className="col-sm-5">  
                                    <img
                                        src={story.attributes?.image?.files?.medium?.url}
                                        alt="story"
                                    />
                                </div>
                                <div className="col-sm-6">  
                                    <div className="row g-12 mt-10">                    
                                        <h4
                                            className="mb-0 text-blue"
                                            dangerouslySetInnerHTML={{ __html: underscoresToHighlights(story?.attributes?.title) }}
                                        />                    
                                    </div>
                                    <div className="mt-30" 
                                        dangerouslySetInnerHTML={{ __html:  underscoresToHighlights(story?.attributes?.paragraph) }}
                                    />
                                    <Link
                                        to={story?.attributes?.link}
                                        className="text-blue hover-text-main-600 mt-20"
                                    >
                                        <div><b>{story?.attributes?.link}</b></div>    
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Story;
